<template>
    <div v-if="ready == true">
        <div class="list-page-header do-not-print-me">
            <div class="list-header-left">
                <div class="breadcrumb">
                    <p>
                        <span class="page-title">Unapproved Members</span>
                    </p>
                </div>
                <div class="flex list-search">
                    <input
                        type="text"
                        v-model="searchTextRaw"
                        placeholder="Search"
                        ref="searchInput"
                        @blur="handleBlur"
                    />
                </div>
            </div>

            <div class="list-header-right">
                <div style="margin-right: 4px;">
                    <select
                        class="match-status-filter"
                        :value="approvalStatusFilter"
                        @change="$emit('approvalStatusFilterChanged', $event)"
                    >
                        <option value="">All Members</option>
                        <option value="unapproved">Unapproved Only</option>
                        <option value="approved">Approved Only</option>
                    </select>
                </div>
                <div style="margin-right: 0;">
                    <select
                        class="match-status-filter"
                        :value="matchStatusFilter"
                        @change="$emit('matchStatusFilterChanged', $event)"
                    >
                        <option value="">All Match Statuses</option>
                        <option value="auto-approved">Full Match</option>
                        <option value="partial">Partial Match</option>
                        <option value="no-match">No Match</option>
                        <option value="not-found">Not Found</option>
                        <option value="not-eligible">Not Eligible</option>
                        <option value="conflict">Conflict</option>
                    </select>
                </div>
                <div style="margin-right: 4px;">
                    <button type="button" class="no-bg match-info-btn" title="Match status guide" @click="showMatchInfoModal = true">&#9432;</button>
                </div>
                <div style="margin-right: 4px;">
                    <button
                        type="button"
                        class="primary"
                        @click="$emit('runMatching')"
                        :disabled="matchLoading"
                    >
                        {{ matchLoading ? 'Matching...' : 'Run Matching' }}
                    </button>
                </div>
                <div style="margin-right: 4px;">
                    <button
                        type="button"
                        class="primary"
                        @click="showApproveMemberModal = true"
                        :disabled="selectedRecords.length == 0 ? true : false"
                        :style="{ visibility: showApproveBtn ? 'visible' : 'hidden' }"
                    >
                        Approve
                    </button>
                </div>
                <div style="margin-right: 4px;">
                    <button
                        type="button"
                        class="primary"
                        @click="showDenyMemberModal = true"
                        :disabled="selectedRecords.length == 0 ? true : false"
                        :style="{ visibility: showRejectBtn ? 'visible' : 'hidden' }"
                    >
                        Deny
                    </button>
                </div>

                <div class="reset-all-criteria">
                    <button @click="clear_criteria" type="button" class="no-bg reset-all-criteria-button">
                        Reset View
                    </button>
                </div>

                <div class="filter-wrap">
                    <button @click="openFilter = !openFilter" type="button" class="no-bg filter-button">Filter</button>
                    <FilterList
                        :filters="JSON.parse(pageMeta.filters)"
                        @getFilters="modifyCriteria"
                        @closeFilter="(close) => (this.openFilter = close)"
                        v-if="openFilter"
                        :selectedFilters="criteria.filter"
                        class="filters-container"
                        id="filter-menu"
                    />
                </div>

                <div class="actions-wrap">
                    <button @click="show_hide_actions" class="actions-button no-bg">Actions</button>
                    <div class="actions-menu dropdown-menu" :class="actions_drop_down">
                        <div class="action-button">
                            <button class="no-bg" @click="export2exel">Export to Excel</button>
                        </div>
                        <div class="action-button">
                            <button class="no-bg" @click="export2csv">Export to CSV</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="custom-list-grid-standard">
            <ejs-grid
                ref="grid"
                :data-source="data_source"
                :allowFiltering="true"
                :allowSorting="true"
                :enableVirtualization="true"
                :rowSelected="onRowSelected"
                :rowDeselected="onRowDeselected"
                :sortSettings="sortOptions"
                :aria-rowcount="100"
                :allowPaging="false"
                :pageSettings="{ pageSize: 100 }"
                :selectionSettings="selectionOptions"
                @queryCellInfo="onQueryCellInfo"
            >
                <e-columns>
                    <e-column
                        v-for="column in formattedColumnMeta"
                        :key="column.field"
                        :field="column.field"
                        :headerText="column.headerText"
                        :allowSorting="column.allowSorting"
                        :editType="column.editType"
                        :type="column.type"
                        :displayAsCheckBox="column.displayAsCheckBox"
                        :textAlign="column.align"
                        :headerTextAlign="column.headerAlign"
                        :width="column.width"
                    ></e-column>
                    <e-column field="eligibility_status" headerText="Eligibility" width="70px" :allowSorting="true"></e-column>
                    <e-column field="match_status" headerText="Match Status" width="100px" :allowSorting="true"></e-column>
                    <e-column field="status" headerText="Status" width="110px" :allowSorting="true"></e-column>
                    <e-column field="reviewer_notes" headerText="Notes" width="120px" :allowSorting="false" clipMode="EllipsisWithTooltip"></e-column>
                    <e-column field="reviewed_by_name" headerText="Reviewed By" width="100px" :allowSorting="true" clipMode="EllipsisWithTooltip"></e-column>
                    <e-column headerText="" field="expand_btn" width="40px" :allowSorting="false" :allowFiltering="false" clipMode="Clip"></e-column>
                </e-columns>
            </ejs-grid>
        </div>
        <paginator
            :total_count="totalCount"
            :pageSize="criteria.page && criteria.page.num_per_page ? criteria.page.num_per_page : 10"
            :storeKey="storeKey"
            :useOverride="useOverride"
            @cancelOverride="$emit('cancelOverride')"
        />

        <ApproveMemberModal
            v-if="showApproveMemberModal"
            :selectedMembers="detailApproveClient ? [detailApproveClient] : selectedRecords"
            @handleApprove="changeActivateStatus"
            @cancel="showApproveMemberModal = false; detailApproveClient = null"
        />

        <DenyMemberModal
            v-if="showDenyMemberModal"
            :selectedMembers="detailDenyClient ? [detailDenyClient] : selectedRecords"
            @handleDeny="changeActivateStatus"
            @cancel="showDenyMemberModal = false; detailDenyClient = null"
        />

        <div v-if="showMatchInfoModal" class="match-info-overlay" @click.self="showMatchInfoModal = false">
            <div class="match-info-modal">
                <div class="match-info-header">
                    <span>Match Status Guide</span>
                    <button class="no-bg" @click="showMatchInfoModal = false">&times;</button>
                </div>
                <div class="match-info-body">
                    <div class="match-info-item">
                        <span class="match-badge match-pending">Pending</span>
                        <p>Matching has not been run yet for this member.</p>
                    </div>
                    <div class="match-info-item">
                        <span class="match-badge match-auto-approved">Full Match</span>
                        <p>Medicaid ID, name, and DOB all match an eligible record. Auto-approved.</p>
                    </div>
                    <div class="match-info-item">
                        <span class="match-badge match-partial">Partial Match</span>
                        <p>Medicaid ID found but only some identity fields (name/DOB) match. Needs manual review.</p>
                    </div>
                    <div class="match-info-item">
                        <span class="match-badge match-no-match">No Match</span>
                        <p>Medicaid ID found but none of the identity fields match. Needs manual review.</p>
                    </div>
                    <div class="match-info-item">
                        <span class="match-badge match-not-found">Not Found</span>
                        <p>Medicaid ID not found in the eligibility file.</p>
                    </div>
                    <div class="match-info-item">
                        <span class="match-badge match-not-eligible">Not Eligible</span>
                        <p>Full identity match but the member is marked as not eligible in the file.</p>
                    </div>
                    <div class="match-info-item">
                        <span class="match-badge match-conflict">Conflict</span>
                        <p>Multiple IDs matched different eligibility records, or this member's record matched multiple clients. Requires manual review.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { debounce } from 'lodash';
    import { GridPlugin, Sort, VirtualScroll, CommandColumn } from '@syncfusion/ej2-vue-grids';
    import ApproveMemberModal from './ApproveMemberModal.vue';
    import DenyMemberModal from './DenyMemberModal.vue';
    import Paginator from '@/components/general/paginator/paginator.vue';
    import { tryGetFilter } from '@/util/tryGetFilter';
    import FilterList from '@/components/general/filter/filter.vue';
    import { Roles } from '@/util/globalConstants';
    import { ledger, clients } from '@/util/apiRequests';
    import dayjs from '@/util/dayjs';
    Vue.use(GridPlugin);

    function makeAssociative(assocCol, data) {
        return data.reduce((out, cur) => {
            out[cur[assocCol]] = cur;
            return out;
        }, {});
    }

    export default {
        components: { Paginator, CommandColumn, FilterList, ApproveMemberModal, DenyMemberModal },
        props: {
            data_source: {
                type: Array,
                default: () => [],
            },
            totalCount: {
                type: Number,
                default: 0,
            },
            column_meta: {
                type: Array,
                required: false,
            },
            storeKey: {
                type: String,
                default: 'invalid_key',
            },
            useOverride: {
                type: Boolean,
                default: false,
            },
            matchLoading: {
                type: Boolean,
                default: false,
            },
            matchStatusFilter: {
                type: String,
                default: '',
            },
            approvalStatusFilter: {
                type: String,
                default: '',
            },
        },
        name: 'UnapprovedClientsList',
        data() {
            return {
                searchBar: null,
                openFilter: false,
                openColumn: false,
                showApproveMemberModal: false,
                showDenyMemberModal: false,
                currentPage: 1,
                sort: {},
                ready: false,
                searchTextRaw: '',
                actions_drop_down: '',
                selectedRecords: [],
                detailApproveClient: null,
                detailDenyClient: null,
                showMatchInfoModal: false,
                selectionOptions: {
                    mode: 'Both',
                    enableToggle: true,
                },
                Roles,
            };
        },
        computed: {
            criteria() {
                let crits = this.useOverride ? this.overrideCriteria : this.savedCriteria;
                if (!crits.page) {
                    crits.page = {
                        current_page: 1,
                        num_per_page: 10,
                    };
                }
                if (!crits.page.current_page) {
                    crits.page.current_page = 1;
                }
                return crits;
            },
            savedCriteria() {
                return tryGetFilter(this.$store, this.storeKey);
            },
            overrideCriteria() {
                return this.$store.getters['filters/overrideCriteria'](this.storeKey);
            },
            sortOptions: {
                get() {
                    const sortKeys = Object.keys(this.criteria?.sort || {});
                    return {
                        columns: sortKeys.map((key) => ({
                            field: key,
                            direction: this.criteria?.sort[key] || 'Ascending',
                        })),
                    };
                },
                set(obj) {
                    return obj;
                },
            },
            searchText() {
                return this.criteria?.search?.like_all || '';
            },
            formattedColumnMeta() {
                return this.column_maker();
            },
            showApproveBtn() {
                if (this.approvalStatusFilter === 'approved') return false;
                return this.criteria?.filter?.status?.length !== 2;
            },
            showRejectBtn() {
                if (this.approvalStatusFilter === 'approved') return false;
                if (this.criteria?.filter?.status?.length === 1) {
                    return !this.criteria?.filter?.status?.includes('Denied');
                }
                return this.criteria?.filter?.status?.length !== 2;
            },
        },
        methods: {
            commandClick: function (args) {
                this.$emit('buttonInCellClicked', args);
            },
            column_maker() {
                const columnMeta = [];
                let rec2push, meta_man, ok2push;

                if (this.column_meta) {
                    meta_man = makeAssociative('field', this.column_meta);
                }

                if (this.data_source.length) {
                    columnMeta.push({
                        type: 'checkbox',
                        field: 'selected',
                        width: '50px',
                    });
                }

                if (this.data_source && this.data_source.length) {
                    const dataSourceModel = this.data_source[0];

                    const skipFields = ['id', 'expand_btn', 'match_status', 'matched_fields', 'eligibility_status', 'activate_status', 'status', 'reviewer_notes', 'reviewed_by_name'];
                    for (const key in dataSourceModel) {
                        if (!skipFields.includes(key) && !this.criteria?.column?.includes(key)) {
                            ok2push = 1;
                            rec2push = {
                                field: key,
                                headerText: this.convertStringToTitleCase(key),
                                allowFiltering: true,
                                allowSorting: true,
                            };

                            const columnWidths = {
                                first_name: '100px',
                                last_name: '100px',
                                phone: '110px',
                                email: '160px',
                            };

                            rec2push.width = columnWidths[key] || '120px';

                            if (meta_man && meta_man[key]) {
                                if (meta_man[key].hide || meta_man[key].hidden) {
                                    ok2push = 0;
                                } else {
                                    for (const [k, v] of Object.entries(meta_man[key])) {
                                        rec2push[k] = v;
                                    }
                                }
                            }
                            if (ok2push) {
                                columnMeta.push(rec2push);
                            }
                        }
                    }
                } else {
                    if (this.column_meta) {
                        for (const metaObj of this.column_meta) {
                            if (metaObj.field !== 'id' && !this.criteria?.column?.includes(metaObj.field)) {
                                columnMeta.push(metaObj);
                            }
                        }
                    }
                }

                return columnMeta;
            },
            convertStringToTitleCase(str) {
                str = str.toString().replaceAll('_', ' ');
                return (str + '').replace(/^([a-z])|\s+([a-z])/g, function ($1) {
                    return $1.toUpperCase();
                });
            },
            onRowSelected(args) {
                this.pushToSelectedRecords(args.data);
            },
            pushToSelectedRecords(data) {
                if (data.length) {
                    // Sometimes this can be an array, like when the select all checkbox is selected
                    data.forEach((d) => this.pushToSelectedRecords(d));
                }
                // Skip already-approved rows
                else if (data.activate_status == 1) {
                    return;
                }
                // Check that the data is not already in the selectedRecords
                else if (this.findIndexOfRecordInSelectedRecords(data) === -1) {
                    this.selectedRecords.push(data);
                }
            },
            findIndexOfRecordInSelectedRecords(data) {
                for (let selectedRecordI in this.selectedRecords) {
                    if (this.objectsMatch(this.selectedRecords[selectedRecordI], data)) {
                        return Number(selectedRecordI);
                    }
                }
                return -1;
            },
            objectsMatch(obj1, obj2) {
                let obj1Keys = Object.keys(obj1);
                let matchingKeyCount = 0;

                for (let obj1Key of obj1Keys) {
                    if (obj2[obj1Key] !== undefined && obj2[obj1Key] === obj1[obj1Key]) {
                        matchingKeyCount++;
                    }
                }

                return matchingKeyCount === obj1Keys.length && obj1Keys.length === Object.keys(obj2).length;
            },
            onRowDeselected(args) {
                if (args.data.length && args.isHeaderCheckboxClicked) {
                    /*
                        args.isHeaderCheckboxClicked == True when the deselection occurs due to the header checkbox being toggled
                        args.isHeaderCheckboxClicked == False when the deselection occurs due to the datasource changing
                    */

                    // this.selectedRecords = this.selectedRecords.filter((record) => {
                    //     for (let d of args.data) {
                    //         if (this.objectsMatch(d, record)) {
                    //             return false;
                    //         }
                    //     }
                    //     return true;
                    // });

                    this.selectedRecords = [];
                } else if (args.isInteracted) {
                    this.selectedRecords = this.selectedRecords.filter(
                        (record) => !this.objectsMatch(args.data, record)
                    );
                }
            },
            debounceSearch: debounce(function () {
                const newCriteria = { ...this.criteria };
                this.$emit('cancelOverride');

                if (this.searchTextRaw.trim()) {
                    newCriteria.search = { like_all: this.searchTextRaw.trim() };
                } else {
                    newCriteria.search = {};
                }

                newCriteria.page = {
                    ...newCriteria.page,
                    page_num: 1,
                };

                this.$store.commit('filters/updateFilter', {
                    stateKey: this.storeKey,
                    criteria: newCriteria,
                });
                this.$refs.searchInput?.focus();
            }, 800),
            getStoreData() {
                this.searchTextRaw = this.searchText;
                this.ready = true;
            },
            handleBlur(e) {
                if (e.relatedTarget?.classList?.contains('e-focus')) {
                    this.$refs.searchInput?.focus();
                }
            },
            clear_criteria() {
                this.searchTextRaw = '';
                this.selectedRecords = [];
                this.$emit('cancelOverride');
                this.$store.commit('filters/applyDefaultFilter', this.storeKey);
            },
            show_hide_actions() {
                if (this.actions_drop_down == '') {
                    this.actions_drop_down = 'show_actions_drop_down';
                } else {
                    this.actions_drop_down = '';
                }
            },
            async export2exel() {
                await this.exportApi('xls');
            },
            async export2csv() {
                await this.exportApi('csv');
            },
            async exportApi(type) {
                if (this.export_api && this.export_api != '/invalid_api') {
                    const exp_source = await this.export_body();

                    if (exp_source) {
                        if (exp_source[0]) {
                            this.exportSource(exp_source, type);
                        }
                    }
                } else {
                    //Default source if no export prop is found
                    if (this.data_source[0]) {
                        this.exportSource(this.data_source, type);
                    }
                }
            },
            async export_body() {
                const body = {
                    criteria: this.criteria,
                };
                const body2 = this.$clone_obj(body);
                body2.criteria.page.num_per_page = 10000;
                body2.criteria.page.page_num = 1;

                try {
                    if (this.export_api == '/ledger/transactions') {
                        const res3 = await this.$api.post(ledger.getTransactionList(), {
                            criteria: {
                                ...body2.criteria,
                                filter: {
                                    ...(this.criteria.filter || {}),
                                    'ledger.client_id': [this.client_id.toString()],
                                },
                            },
                            clientId: this.client_id,
                        });
                        const rows3 = res3.data.rows.map((row) => {
                            return {
                                id: row.id,
                                dayt_create: dayjs(row.date).format('MM/DD/YYYY'),
                                description: row.description,
                                charge_total: row.charge_total,
                                payment_total: row.payment_total,
                                type: row.type,
                                rawPayment: row.payment,
                                paymentType: row.paymentType,
                                paymentIntentId: row.stripePaymentIntentId,
                                availableForRefund: row.availableForRefund,
                            };
                        });
                        return rows3;
                    } else {
                        const res2 = await this.$api.post(this.export_api, body2);
                        return res2.data.rows;
                    }
                } catch (e) {
                    //Error: Invalid api root
                }
                return null;
            },
            exportSource(source, type) {
                let sresult = this.autoFormatExport(source);
                let headers = Object.entries(sresult[0]);
                //Get column names of the initial criteria, excluding the id
                let c_meta = this.column_meta
                    .filter((v) => !(v['field'] === 'id' || ('hide' in v && v.hide)))
                    .map((v) => v['field']);
                //Get and filter column headers based on current criteria
                let csv =
                    headers
                        .filter((v) => c_meta.includes(v[0]) && !this.criteria?.column?.includes(v[0]))
                        .map((v) => v[0])
                        .join(type === 'xls' ? '\t' : ',') + '\n';
                //List rows of results based on current and filtered criteria
                sresult.forEach((row) => {
                    csv +=
                        Object.entries(row)
                            .filter((v) => c_meta.includes(v[0]) && !this.criteria?.column?.includes(v[0]))
                            .map((v) => v[1])
                            .join(type === 'xls' ? '\t' : ',') + '\n';
                });
                const format_type =
                    type === 'xls' ? 'application/vnd.ms-excel;charset=utf-8' : 'text/csv;charset=utf-8';
                this.export2file(csv, format_type, type);
            },
            export2file(content, data_type, ext) {
                const anchor = document.createElement('a');
                anchor.href = 'data:' + data_type + ',' + encodeURIComponent(content);
                anchor.target = '_blank';
                anchor.download = this.storeKey + '.' + ext;
                anchor.click();
            },
            autoFormatExport(source) {
                let result = source;
                if (result.length) {
                    if (this.criteria.column && this.criteria.column.length > 0) {
                        let columnsToHide = this.criteria.column;
                        result = source.map((element) => {
                            let elementTemp = {};
                            for (let key in element) {
                                if (columnsToHide.indexOf(key) == -1) {
                                    elementTemp[key] = element[key];
                                }
                            }
                            return elementTemp;
                        });
                    }

                    for (const [k, v] of Object.entries(result)) {
                        for (const [k2, v2] of Object.entries(v)) {
                            let field = k2.toLowerCase();
                            if (
                                field.includes('total') ||
                                field.includes('amount') ||
                                field.includes('cost') ||
                                field.includes('price') ||
                                field.includes('dollars') ||
                                field.includes('balance')
                            ) {
                                result[k][k2] = this.$getCurrency(v2);
                            }
                            if ((field.includes('date') || field.includes('dayt')) && !this.ignoreDateConversion) {
                                result[k][k2] = this.getShortDate(v2);
                            }
                        }
                    }
                }
                return result;
            },
            async modifyCriteria(type, data) {
                const newCriteria = { ...this.criteria };
                switch (type) {
                    case 'column':
                        newCriteria.column = data;
                        this.doSort();
                        this.openColumn = false;

                        this.$emit('cancelOverride');

                        this.$store.commit('filters/updateFilter', {
                            stateKey: this.storeKey,
                            criteria: newCriteria,
                        });

                        break;
                    case 'sort':
                        const { header, direction } = data;
                        const [sortKey] = Object.keys(newCriteria.sort);

                        // Do nothing if no sort currently applied and the sort command is empty
                        if (header === undefined && sortKey === undefined) {
                            break;
                        }

                        // Do nothing if list is already sorted in the way described by the sort command
                        if (header === sortKey && newCriteria.sort[sortKey] === direction) {
                            break;
                        }

                        if (data.header && data.direction) {
                            newCriteria.sort = { [data.header]: data.direction };
                        } else {
                            newCriteria.sort = {};
                        }

                        this.$emit('cancelOverride');

                        this.$store.commit('filters/updateFilter', {
                            stateKey: this.storeKey,
                            criteria: newCriteria,
                        });

                        break;
                    case 'pagination':
                        const { num_per_page, page_num } = data;
                        newCriteria.page = { num_per_page, page_num };

                        this.$emit('cancelOverride');

                        this.$store.commit('filters/updateFilter', {
                            stateKey: this.storeKey,
                            criteria: newCriteria,
                        });

                        break;
                    case 'filter':
                        this.openFilter = false;
                        newCriteria.filter = data;

                        this.$emit('cancelOverride');

                        this.$store.commit('filters/updateFilter', {
                            stateKey: this.storeKey,
                            criteria: newCriteria,
                        });

                        break;
                    case 'search':
                        if (data.term) {
                            newCriteria.search = { like_all: data.term };
                        } else {
                            newCriteria.search = {};
                        }

                        this.$emit('cancelOverride');

                        this.$store.commit('filters/updateFilter', {
                            stateKey: this.storeKey,
                            criteria: newCriteria,
                        });

                        break;
                    case 'date_range':
                        newCriteria.date_range = data;

                        this.$emit('cancelOverride');

                        this.$store.commit('filters/updateFilter', {
                            stateKey: this.storeKey,
                            criteria: newCriteria,
                        });

                        break;
                    default:
                        break;
                }
            },
            onQueryCellInfo(args) {
                const field = args.column.field;
                const data = args.data;
                const cell = args.cell;

                // Disable checkbox for already-approved rows
                if (args.column.type === 'checkbox' && data.activate_status == 1) {
                    const checkbox = cell.querySelector('.e-frame');
                    if (checkbox) {
                        checkbox.style.pointerEvents = 'none';
                        checkbox.style.opacity = '0.4';
                    }
                    cell.style.pointerEvents = 'none';
                }

                // Add tooltip for truncated cell values
                const val = data[field];
                if (val !== null && val !== undefined && val !== '') {
                    cell.title = String(val);
                }
                if (field === 'status') {
                    const val = (data.status || '').toString();
                    const span = document.createElement('span');
                    span.className = 'status-badge';
                    if (val === 'Unapproved') {
                        span.className += ' status-unapproved';
                    } else if (val === 'Active') {
                        span.className += ' status-active';
                    } else if (val === 'Denied') {
                        span.className += ' status-denied';
                    } else {
                        span.className += ' status-default';
                    }
                    span.textContent = val;
                    cell.textContent = '';
                    cell.style.textAlign = 'left';
                    cell.appendChild(span);
                } else if (field === 'expand_btn') {
                    const isExpanded = this._expandedRows && this._expandedRows.has(data.id);
                    const btn = document.createElement('button');
                    btn.className = 'no-bg expand-btn';
                    btn.title = isExpanded ? 'Collapse details' : 'View match details';
                    btn.textContent = isExpanded ? '−' : '+';
                    btn.onclick = (e) => {
                        e.stopPropagation();
                        if (!this._expandedRows) this._expandedRows = new Set();
                        this.toggleDetailRow(data.id, args.cell.closest('tr'));
                        if (this._expandedRows.has(data.id)) {
                            this._expandedRows.delete(data.id);
                            btn.textContent = '+';
                            btn.title = 'View match details';
                        } else {
                            this._expandedRows.add(data.id);
                            btn.textContent = '−';
                            btn.title = 'Collapse details';
                        }
                    };
                    cell.textContent = '';
                    cell.appendChild(btn);
                } else if (field === 'match_status') {
                    cell.textContent = '';
                    const matchVal = data.match_status || 'pending';
                    const label = this.matchStatusLabel(matchVal);
                    const span = document.createElement('span');
                    span.className = 'match-badge match-' + matchVal;
                    span.textContent = label;
                    cell.appendChild(span);
                } else if (field === 'matched_fields' && data.matched_fields) {
                    const fields = this.parseMatchedFields(data.matched_fields);
                    const total = Object.keys(fields).length;
                    const matched = Object.values(fields).filter(v => v).length;
                    const container = document.createElement('span');
                    if (matched === total) {
                        container.className = 'fields-count fields-count-green';
                    } else if (matched === 0) {
                        container.className = 'fields-count fields-count-red';
                    } else {
                        container.className = 'fields-count fields-count-yellow';
                    }
                    container.innerHTML = '<span class="fields-num">' + matched + '/' + total + '</span>';
                    // Add individual field icons
                    for (const [key, val] of Object.entries(fields)) {
                        const icon = document.createElement('span');
                        icon.className = val ? 'field-icon-check' : 'field-icon-cross';
                        icon.title = this.convertStringToTitleCase(key);
                        icon.textContent = val ? '\u2713' : '\u2717';
                        container.appendChild(icon);
                    }
                    cell.textContent = '';
                    cell.appendChild(container);
                } else if (field === 'reviewer_notes') {
                    const val = data.reviewer_notes;
                    if (!val || val === '') {
                        cell.textContent = '—';
                        cell.style.color = '#bbb';
                    }
                } else if (field === 'reviewed_by_name') {
                    const val = data.reviewed_by_name;
                    if (!val || val === '') {
                        cell.textContent = '—';
                        cell.style.color = '#bbb';
                    }
                } else if (field === 'eligibility_status') {
                    cell.textContent = '';
                    const val = data.eligibility_status;
                    if (val !== null && val !== undefined && val !== '') {
                        const isActive = val == 1 || val === 'Active' || val === 'active';
                        const span = document.createElement('span');
                        span.className = 'match-badge ' + (isActive ? 'match-active' : 'match-inactive');
                        span.textContent = isActive ? 'Yes' : 'No';
                        cell.appendChild(span);
                    } else {
                        cell.textContent = '—';
                        cell.style.color = '#bbb';
                    }
                }
            },
            matchStatusLabel(status) {
                const labels = {
                    'pending': 'Pending',
                    'auto-approved': 'Full Match',
                    'partial': 'Partial Match',
                    'no-match': 'No Match',
                    'not-found': 'Not Found',
                    'not-eligible': 'Not Eligible',
                    'conflict': 'Conflict',
                };
                return labels[status] || status;
            },
            parseMatchedFields(fields) {
                if (!fields) return {};
                if (typeof fields === 'string') {
                    try { return JSON.parse(fields); } catch { return {}; }
                }
                return fields;
            },
            toggleDetailRow(clientId, parentRow) {
                // If already expanded, collapse
                const existing = document.getElementById('detail-row-' + clientId);
                if (existing) {
                    existing.remove();
                    const btn = parentRow.querySelector('.expand-btn');
                    if (btn) btn.classList.remove('expanded');
                    return;
                }

                // Collapse any other open detail row
                const prev = document.querySelector('.injected-detail-row');
                if (prev) {
                    prev.remove();
                    document.querySelectorAll('.expand-btn.expanded').forEach(b => b.classList.remove('expanded'));
                }

                // Mark as expanded
                const btn = parentRow.querySelector('.expand-btn');
                if (btn) btn.classList.add('expanded');

                // Create detail <tr>
                const colCount = parentRow.cells.length;
                const detailTr = document.createElement('tr');
                detailTr.id = 'detail-row-' + clientId;
                detailTr.className = 'injected-detail-row';
                const detailTd = document.createElement('td');
                detailTd.colSpan = colCount;
                detailTd.innerHTML = '<div class="detail-content"><div class="detail-loading">Loading match details...</div></div>';
                detailTr.appendChild(detailTd);
                parentRow.after(detailTr);

                const vm = this;
                const endpoint = clients.getMatchDetails(clientId);

                this.$api.get(endpoint).then(res => {
                    if (!res.data.success || !res.data.data) {
                        detailTd.innerHTML = '<div class="detail-content"><div class="detail-empty">Not yet matched — run matching first</div></div>';
                        return;
                    }
                    const md = res.data.data;
                    const matchFields = vm.parseMatchedFields(md.match.matched_fields);
                    const statusLabel = vm.matchStatusLabel(md.match.match_status);
                    const statusClass = 'match-' + md.match.match_status;
                    const fields = ['medicaid_id', 'first_name', 'last_name', 'dob'];

                    const formatDob = (val) => {
                        if (!val) return '—';
                        const d = new Date(val);
                        if (isNaN(d.getTime())) return val;
                        return String(d.getUTCMonth() + 1).padStart(2, '0') + '-' + String(d.getUTCDate()).padStart(2, '0') + '-' + d.getUTCFullYear();
                    };

                    const formatFieldValue = (f, obj) => {
                        if (!obj) return '—';
                        const val = obj[f];
                        if (val === null || val === undefined || val === '') return '—';
                        if (f === 'dob') return formatDob(val);
                        return val;
                    };

                    let regRows = '';
                    if (md.registration) {
                        fields.forEach(f => {
                            const matched = matchFields[f];
                            const icon = matched
                                ? '<span class="detail-icon-check">\u2713</span>'
                                : '<span class="detail-icon-cross">\u2717</span>';
                            regRows += '<div class="comparison-row">' + (md.match.matched_fields ? icon : '') + '<span class="field-label">' + vm.convertStringToTitleCase(f) + '</span><span class="field-value">' + formatFieldValue(f, md.registration) + '</span></div>';
                        });
                    }

                    let eligRows = '';
                    if (md.eligibility) {
                        fields.forEach(f => {
                            const matched = matchFields[f];
                            const icon = matched
                                ? '<span class="detail-icon-check">\u2713</span>'
                                : '<span class="detail-icon-cross">\u2717</span>';
                            eligRows += '<div class="comparison-row">' + (md.match.matched_fields ? icon : '') + '<span class="field-label">' + vm.convertStringToTitleCase(f) + '</span><span class="field-value">' + formatFieldValue(f, md.eligibility) + '</span></div>';
                        });
                        const eligActive = md.eligibility.eligibility_status == 1;
                        eligRows += '<div class="comparison-row"><span class="detail-icon-spacer"></span><span class="field-label">Eligibility Status</span><span class="eligibility-pill ' + (eligActive ? 'eligibility-active' : 'eligibility-inactive') + '">' + (eligActive ? 'Yes' : 'No') + '</span></div>';
                    } else {
                        fields.forEach(f => {
                            eligRows += '<div class="comparison-row"><span class="detail-icon-spacer"></span><span class="field-label">' + vm.convertStringToTitleCase(f) + '</span><span class="field-value" style="color:#999; font-style:italic;">Not Found</span></div>';
                        });
                        eligRows += '<div class="comparison-row"><span class="detail-icon-spacer"></span><span class="field-label">Eligibility Status</span><span class="field-value" style="color:#999; font-style:italic;">Not Found</span></div>';
                    }

                    // Determine if this row is read-only (already approved or denied)
                    const rowData = vm.data_source.find(r => r.id === clientId);
                    const isApproved = rowData && (rowData.activate_status == 1 || rowData.status === 'Active');
                    const isDenied = rowData && rowData.status === 'Denied';
                    const isReadOnly = isApproved || isDenied;

                    let actionHtml = '';
                    const isConflict = md.match.match_status === 'conflict';
                    const disableApprDeny = isApproved || isDenied || md.match.match_status === 'auto-approved' || isConflict;
                    if (isApproved) {
                        actionHtml = '<span class="status-pill status-auto-approved" style="margin-right:8px;">Approved</span>';
                    } else if (isDenied) {
                        actionHtml = '<span class="status-pill status-denied-pill" style="margin-right:8px;">Denied</span>';
                    }
                    actionHtml += '<button type="button" class="btn-save-notes save-notes-button" data-client-id="' + clientId + '">Save Notes</button>';
                    actionHtml += ' <button type="button" class="btn-approve detail-approve-button" data-client-id="' + clientId + '"' + (disableApprDeny ? ' disabled' : '') + '>Approve</button>';
                    actionHtml += ' <button type="button" class="btn-deny detail-deny-button" data-client-id="' + clientId + '"' + (disableApprDeny ? ' disabled' : '') + '>Deny</button>';

                    detailTd.innerHTML =
                        '<div class="detail-content">' +
                            '<div class="detail-header">' +
                                '<span class="match-badge ' + statusClass + '">' + statusLabel + '</span>' +
                                '<span class="detail-title">Match Details</span>' +
                            '</div>' +
                            '<div class="match-comparison">' +
                                '<div class="comparison-side"><h5>Registration</h5><div class="comparison-fields">' + regRows + '</div></div>' +
                                '<div class="comparison-side"><h5>Eligibility File</h5><div class="comparison-fields">' + eligRows + '</div></div>' +
                            '</div>' +
                            '<div class="review-section">' +
                                '<div class="review-notes-area"><label>Reviewer Notes</label>' +
                                    '<textarea class="review-textarea" data-client-id="' + clientId + '" placeholder="Add notes...">' + (md.match.reviewer_notes || '') + '</textarea>' +
                                    '<div class="review-action">' + actionHtml + '</div>' +
                                '</div>' +
                            '</div>' +
                        '</div>';

                    // Bind textarea blur
                    const textarea = detailTd.querySelector('.review-textarea');
                    if (textarea) {
                        textarea.addEventListener('blur', () => {
                            vm.$api.post(clients.matchReview(), {
                                clientId: clientId,
                                reviewer_notes: textarea.value,
                                action: null,
                            }).catch(err => {
                                console.error('Failed to save notes:', err);
                                vm.$toasted.error('Failed to save reviewer notes');
                            });
                        });
                    }

                    // Bind Save Notes button
                    const saveNotesBtn = detailTd.querySelector('.save-notes-button');
                    if (saveNotesBtn) {
                        saveNotesBtn.addEventListener('click', async () => {
                            saveNotesBtn.disabled = true;
                            saveNotesBtn.textContent = 'Saving...';
                            try {
                                await vm.$api.post(clients.matchReview(), {
                                    clientId: clientId,
                                    reviewer_notes: textarea ? textarea.value : '',
                                    action: 'hold',
                                });
                                vm.$toasted.success('Notes saved');
                                saveNotesBtn.disabled = false;
                                saveNotesBtn.textContent = 'Save Notes';
                            } catch (err) {
                                console.error('Failed to save notes:', err);
                                vm.$toasted.error('Failed to save notes');
                                saveNotesBtn.disabled = false;
                                saveNotesBtn.textContent = 'Save Notes';
                            }
                        });
                    }

                    // Bind detail Approve button — opens clinician+tags modal
                    const approveBtn = detailTd.querySelector('.detail-approve-button');
                    if (approveBtn) {
                        approveBtn.addEventListener('click', async () => {
                            // Save reviewer notes first
                            if (textarea) {
                                await vm.$api.post(clients.matchReview(), {
                                    clientId: clientId,
                                    reviewer_notes: textarea.value,
                                    action: null,
                                }).catch(() => {});
                            }
                            const row = vm.data_source.find(r => r.id === clientId);
                            if (row) {
                                vm.detailApproveClient = row;
                                vm.showApproveMemberModal = true;
                            }
                        });
                    }

                    // Bind detail Deny button — opens confirmation modal
                    const denyBtn = detailTd.querySelector('.detail-deny-button');
                    if (denyBtn) {
                        denyBtn.addEventListener('click', async () => {
                            // Save reviewer notes first
                            if (textarea) {
                                await vm.$api.post(clients.matchReview(), {
                                    clientId: clientId,
                                    reviewer_notes: textarea.value,
                                    action: null,
                                }).catch(() => {});
                            }
                            const row = vm.data_source.find(r => r.id === clientId);
                            if (row) {
                                vm.detailDenyClient = row;
                                vm.showDenyMemberModal = true;
                            }
                        });
                    }
                }).catch(err => {
                    console.error('Failed to load match details:', err);
                    detailTd.innerHTML = '<div class="detail-content"><div class="detail-empty">Failed to load match details</div></div>';
                });
            },
            async changeActivateStatus(type, val = {}) {
                this.showApproveMemberModal = false;
                this.showDenyMemberModal = false;

                // Use single-detail client if set, otherwise bulk selected records
                const members = this.detailApproveClient
                    ? [this.detailApproveClient]
                    : this.detailDenyClient
                        ? [this.detailDenyClient]
                        : this.selectedRecords;

                let data = {
                    ...val,
                    emails: [],
                    phoneNumbers: [],
                    status: type,
                    activate_status: type === 'Active' ? 1 : 0,
                };
                members.forEach((item) => {
                    if (item.email) {
                        data.emails.push(item.email);
                    }
                    if (item.phone) {
                        data.phoneNumbers.push(item.phone);
                    }
                });

                this.detailApproveClient = null;
                this.detailDenyClient = null;
                this.$emit('approveClients', data);
            },
        },
        created() {
            this.getStoreData();
        },
        provide: {
            grid: [Sort, VirtualScroll, CommandColumn],
        },
        watch: {
            searchTextRaw() {
                this.debounceSearch();
            },
            approvalStatusFilter() {
                this.selectedRecords = [];
            },
            data_source: function (newDataSource) {
                let indexesThatShouldBeSelected = [];

                // Compare selected records to the new data source and find all matches.
                for (let i in newDataSource) {
                    if (this.findIndexOfRecordInSelectedRecords(newDataSource[i]) !== -1) {
                        indexesThatShouldBeSelected.push(i);
                    }
                }
                /*
                    This timeout is used to wait for the grid to finish updating with the new datasource before selecting the rows.
                    Getting the element by class name and clicking it is hacky, but syncfusion sucks and this was the only
                    way I could find of selecting the row without having the user click twice to unselect it again.
                */
                setTimeout(
                    () =>
                        indexesThatShouldBeSelected.forEach((i) =>
                            document.getElementsByClassName('e-gridchkbox')[i].click()
                        ),
                    100
                );
            },
        },
    };
</script>

<style scoped>
    button:disabled {
        background: gray !important;
        cursor: no-drop;
    }

    div.list-header-right div.actions-wrap div.show_actions_drop_down {
        visibility: visible;
    }
    .match-status-filter {
        padding: 6px 10px;
        border: 1px solid #ccc;
        border-radius: 5px;
        font-size: 1rem;
        background: white;
        width: 150px;
    }
</style>

<style>
    /* --- Reduce gap between search and controls --- */
    .list-page-header .list-header-left .list-search {
        max-width: 180px !important;
        margin-right: 4px !important;
    }
    /* --- Match info button and modal --- */
    .match-info-btn {
        font-size: 18px;
        color: #666;
        cursor: pointer;
        padding: 0 4px 0 2px !important;
        line-height: 1;
    }
    .match-info-btn:hover { color: #333; }
    .match-info-overlay {
        position: fixed;
        top: 0; left: 0; right: 0; bottom: 0;
        background: rgba(0,0,0,0.3);
        display: flex;
        align-items: center;
        justify-content: center;
        z-index: 9999;
    }
    .match-info-modal {
        background: white;
        border-radius: 10px;
        width: 480px;
        max-height: 80vh;
        overflow-y: auto;
        box-shadow: 0 8px 32px rgba(0,0,0,0.2);
    }
    .match-info-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px 20px;
        border-bottom: 1px solid #eee;
        font-weight: 700;
        font-size: 16px;
    }
    .match-info-header button {
        font-size: 22px;
        color: #999;
        cursor: pointer;
    }
    .match-info-body {
        padding: 16px 20px;
    }
    .match-info-item {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        padding: 10px 0;
        border-bottom: 1px solid #f5f5f5;
    }
    .match-info-item:last-child { border-bottom: none; }
    .match-info-item .match-badge {
        flex-shrink: 0;
        min-width: 100px;
        text-align: center;
    }
    .match-info-item p {
        margin: 0;
        font-size: 13px;
        color: #555;
        line-height: 1.4;
    }
    /* --- Unchecked checkbox visibility --- */
    .e-grid .e-frame.e-icons:not(.e-check) {
        border: 1px solid #aaa !important;
    }
    /* --- Checkbox column fix --- */
    .e-grid th.e-headercell:first-child,
    .e-grid td.e-rowcell.e-gridchkbox {
        padding: 4px !important;
    }
    .e-grid .e-checkbox-wrapper .e-label {
        display: none !important;
    }
    /* --- Status pill badge --- */
    .status-badge {
        display: inline-block !important;
        padding: 4px 14px !important;
        border-radius: 999px !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        letter-spacing: 0.3px;
        white-space: nowrap;
    }
    .status-unapproved { background: #fff8e1 !important; color: #856404 !important; border: 1.5px solid #f0d76a !important; }
    .status-active { background: #e8f5e9 !important; color: #2e7d32 !important; border: 1.5px solid #81c784 !important; }
    .status-denied { background: #fce4ec !important; color: #c62828 !important; border: 1.5px solid #ef9a9a !important; }
    .status-default { background: #f5f5f5 !important; color: #616161 !important; border: 1.5px solid #bdbdbd !important; }

    /* --- Match status pill badge --- */
    .match-badge {
        display: inline-block !important;
        padding: 4px 14px !important;
        border-radius: 999px !important;
        font-size: 12px !important;
        font-weight: 600 !important;
        letter-spacing: 0.3px;
        white-space: nowrap;
    }
    .match-pending { background: #e3f2fd !important; color: #1565c0 !important; border: 1.5px solid #90caf9 !important; }
    .match-auto-approved { background: #e8f5e9 !important; color: #2e7d32 !important; border: 1.5px solid #81c784 !important; }
    .match-partial { background: #fff8e1 !important; color: #856404 !important; border: 1.5px solid #f0d76a !important; }
    .match-no-match { background: #fce4ec !important; color: #c62828 !important; border: 1.5px solid #ef9a9a !important; }
    .match-not-found { background: #f5f5f5 !important; color: #616161 !important; border: 1.5px solid #bdbdbd !important; }
    .match-not-eligible { background: #fff3e0 !important; color: #e65100 !important; border: 1.5px solid #ffb74d !important; }
    .match-conflict     { background: #ffe0b2 !important; color: #f57c00 !important; border: 1.5px solid #ffb74d !important; }
    .match-active { background: #e8f5e9 !important; color: #2e7d32 !important; border: 1.5px solid #81c784 !important; }
    .match-inactive { background: #fce4ec !important; color: #c62828 !important; border: 1.5px solid #ef9a9a !important; }

    /* --- Fields count (N/4) --- */
    .fields-count {
        display: inline-flex !important;
        align-items: center;
        gap: 4px;
        padding: 2px 8px !important;
        border-radius: 12px !important;
        font-size: 12px !important;
        font-weight: 600 !important;
    }
    .fields-num { margin-right: 2px; }
    .fields-count-green { background: #d4edda !important; color: #155724 !important; }
    .fields-count-yellow { background: #fff3cd !important; color: #856404 !important; }
    .fields-count-red { background: #f8d7da !important; color: #721c24 !important; }
    .field-icon-check { color: #28a745; font-size: 11px; font-weight: bold; }
    .field-icon-cross { color: #dc3545; font-size: 11px; font-weight: bold; }

    /* --- Expand button in grid cell --- */
    .expand-btn {
        cursor: pointer;
        font-size: 20px;
        font-weight: bold;
        padding: 2px 8px;
        color: #666;
        display: inline-block;
        line-height: 1;
        border-radius: 4px;
    }
    .expand-btn:focus {
        outline: none;
    }
    .expand-btn:hover { color: #333; }
    .expand-btn.expanded {
        color: var(--button-color, #8b1a1a);
    }

    /* --- Injected detail row (child row inside grid table) --- */
    .injected-detail-row td {
        padding: 0 !important;
        border: none !important;
    }
    .detail-content {
        padding: 14px 20px;
        background: #f8f9fa;
        border-left: 3px solid var(--button-color, #8b1a1a);
    }
    .detail-header {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 12px;
    }
    .detail-title {
        font-size: 15px;
        font-weight: 600;
        color: #333;
    }
    .detail-loading, .detail-empty {
        padding: 16px;
        text-align: center;
        color: #666;
        font-style: italic;
    }
    .match-comparison {
        display: flex;
        gap: 16px;
    }
    .comparison-side {
        flex: 1;
        border: 1px solid #e0e0e0;
        border-radius: 6px;
        padding: 12px;
        background: white;
    }
    .comparison-side h5 {
        margin: 0 0 8px 0;
        font-size: 12px;
        font-weight: 700;
        color: #555;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }
    .comparison-row {
        display: flex;
        align-items: center;
        padding: 5px 0;
        border-bottom: 1px solid #f0f0f0;
    }
    .comparison-row:last-child { border-bottom: none; }
    .field-label { flex: 0 0 110px; font-weight: 600; font-size: 12px; color: #666; }
    .field-value { flex: 1; font-size: 13px; color: #333; }
    .field-match { color: #28a745; font-weight: bold; margin-left: 8px; }
    .field-mismatch { color: #dc3545; font-weight: bold; margin-left: 8px; }

    /* --- Detail row check/cross icons (like Figma) --- */
    .detail-icon-spacer {
        flex: 0 0 24px;
    }
    .detail-icon-check {
        color: #28a745;
        font-size: 14px;
        font-weight: bold;
        flex: 0 0 24px;
        text-align: center;
    }
    .detail-icon-cross {
        color: #dc3545;
        font-size: 14px;
        font-weight: bold;
        flex: 0 0 24px;
        text-align: center;
    }

    /* --- Eligibility pill in detail row --- */
    .eligibility-pill {
        display: inline-block !important;
        padding: 4px 14px !important;
        border-radius: 999px !important;
        font-size: 12px !important;
        font-weight: 600 !important;
    }
    .eligibility-active { background: #e8f5e9 !important; color: #2e7d32 !important; border: 1.5px solid #81c784 !important; }
    .eligibility-inactive { background: #fce4ec !important; color: #c62828 !important; border: 1.5px solid #ef9a9a !important; }

    /* --- Review section --- */
    .review-section {
        margin-top: 12px;
    }
    .review-notes-area { min-width: 0; }
    .review-notes-area label {
        display: block;
        font-weight: 600;
        margin-bottom: 4px;
        font-size: 12px;
        color: #555;
        text-transform: uppercase;
        letter-spacing: 0.5px;
    }
    .review-textarea {
        width: 100%;
        min-height: 48px;
        padding: 8px;
        border: 1px solid #ddd;
        border-radius: 4px;
        font-size: 13px;
        resize: vertical;
        box-sizing: border-box;
        font-family: inherit;
    }
    .review-action { margin-top: 8px; display: flex; justify-content: flex-end; gap: 8px; }
    .btn-save-notes {
        white-space: nowrap;
        font-size: 13px;
        padding: 8px 16px;
        cursor: pointer;
        background: var(--button-color, #8b1a1a) !important;
        color: #fff !important;
        border: 1.5px solid var(--button-color, #8b1a1a) !important;
        border-radius: 5px;
        font-weight: 600;
    }
    .btn-save-notes:hover { opacity: 0.9; }
    .btn-save-notes:disabled { background: gray !important; cursor: no-drop; }
    .btn-approve {
        white-space: nowrap;
        font-size: 13px;
        padding: 8px 16px;
        cursor: pointer;
        background: #2e7d32 !important;
        color: #fff !important;
        border: 1.5px solid #2e7d32 !important;
        border-radius: 5px;
        font-weight: 600;
    }
    .btn-approve:hover:not(:disabled) { opacity: 0.9; }
    .btn-approve:disabled { background: #ccc !important; cursor: not-allowed; opacity: 0.6; pointer-events: none; }
    .btn-deny {
        white-space: nowrap;
        font-size: 13px;
        padding: 8px 16px;
        cursor: pointer;
        background: #c62828 !important;
        color: #fff !important;
        border: 1.5px solid #c62828 !important;
        border-radius: 5px;
        font-weight: 600;
    }
    .btn-deny:hover:not(:disabled) { opacity: 0.9; }
    .btn-deny:disabled { background: #ccc !important; cursor: not-allowed; opacity: 0.6; pointer-events: none; }
    .status-pill {
        display: inline-block;
        padding: 6px 14px;
        border-radius: 12px;
        font-size: 12px;
        font-weight: 600;
        white-space: nowrap;
    }
    .status-auto-approved { background: #d4edda; color: #155724; }
    .status-denied-pill { background: #f8d7da; color: #721c24; }
    .status-held { background: #e2e3e5; color: #383d41; }
</style>
